















































































































































































































































































































































































































































import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { CustomerAreaSetting } from '@core/interfaces/customer-area-setting';
import FormProvider from '@shared/components/forms/form-provider.vue';
import CssEditor from '@shared/components/forms/inputs/css-editor/css-editor.vue';
import Input from '@shared/components/forms/inputs/input/input.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import Switch from '@shared/components/forms/inputs/switch/switch.vue';
import Textarea from '@shared/components/forms/inputs/textarea/textarea.vue';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { customer_area_setting } from '@/config/customer_area_setting';
import BpcSection from '@shared/components/forms/inputs/section/section.vue';
@Component({
  name: 'bpc-customer-area-setting-form',
  components: {
    'bpc-form-provider': FormProvider,
    'bpc-input': Input,
    'bpc-select': Select,
    'bpc-textarea': Textarea,
    'bpc-css-editor': CssEditor,
    'bpc-switch': Switch,
    'bpc-section': BpcSection,
  },
})
export default class CustomerAreaSettingForm extends Vue {
  $refs!: {
    formProvider: InstanceType<typeof FormProvider> & {
      errorsObject: object;
      saveEntity(formModel: AnyEntity): Promise<BPCGenericApiResponse>;
      resetErrorObject(): void;
    };
  };
  // PROPS
  // @Prop({ type: String, default: '' }) readonly myStrProp: string;
  // @Prop({ type: Object, default() {return {};}}) readonly myObjectProp: MyInterface;

  // DATA
  public formModel: CustomerAreaSetting = null;
  modelLoaded: boolean = false;

  // LIFECYCLE
  // created(){}
  // mounted(){}
  // updated(){}
  // destroyed(){}

  // COMPUTED

  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  get fieldsConfig() {
    return customer_area_setting;
  }
  // METHODS

  onEntitySaved(e) {
    this.$emit('entity-saved', e);
  }

  onEntityErrorSaving(e) {
    this.$bpcMessage.showErrorMessage({
      text: 'core.superadmin_form_update_errors',
    });
    this.$emit('entity-error-saving', e);
  }

  onValidationWarning(e) {
    this.$emit('validation-warning', e);
  }

  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }

  onModelLoaded(event) {
    this.$emit('model-loaded', event);
    this.modelLoaded = true;
  }

  onConfigLoaded(event) {
    this.$emit('config-loaded', event);
  }
}
